<div class="store-receipt-container">
	<div class="texture-background">
		<sp-image [imageFilename]="'texture'" [altImageLabel]="'Texture background'"></sp-image>
	</div>

	<div class="logo-container">
		<sp-image [imageFilename]="'logo-name'" [altImageLabel]="'Scoutly Plans Logo'"></sp-image>
		<div class="logo-icon-container">
			<sp-image [imageFilename]="'logo-icon'" [altImageLabel]="'Scoutly Plans Logo'"></sp-image>
		</div>
	</div>

	<div class="country-image-container">
		<sp-image class="country-image-line" [imageFilename]="'curved-dash-line'" [altImageLabel]="'dash-line'"></sp-image>
		<div class="country-image-overlay"></div>
		<sp-pill class="country-name-pill" [filename]="'location-on-bkg'" [color]="'yellow'">{{
			countryName() | propertitlecase
		}}</sp-pill>
		<sp-image [imageFilename]="countryNameImage()" [isJpg]="true" [altImageLabel]="'Country image'"></sp-image>
	</div>

	@if (paymentSucceeded()) {
		<!-- Success State - Only show success message -->
		<div class="success-message">
			<div class="store-receipt-title">ORDER SUMMARY</div>

			<div class="store-receipt-type-container">
				<div class="store-receipt-type-icon-container">
					<sp-icon class="icon-teal-gold store-receipt-type-icon" [filename]="'dashboard'"></sp-icon>
					<div class="store-receipt-type-title">{{ selectedProduct()?.title | propertitlecase }}</div>
				</div>
				<div class="store-receipt-type-cost">{{ selectedProduct()?.label | currency }}</div>
			</div>
			<div class="store-receipt-type-details">
				<ul class="store-receipt-type-details-list">
					<li>Unlimited Dashboard Access</li>
					<li>Discounted upgrades</li>
				</ul>
			</div>

			<div class="store-receipt-country-container">
				<div class="store-receipt-country-icon-container">
					<sp-icon class="icon-teal-gold store-receipt-country-icon" [filename]="'location-on-bkg'"></sp-icon>
					<div class="store-receipt-country-title">{{ countryName() | propertitlecase }}</div>
				</div>
				<div class="store-receipt-country-cost">{{ 0.0 | currency }}</div>
			</div>
			<div class="store-receipt-country-details">
				<ul class="store-receipt-country-details-list">
					<li>Free with {{ selectedProduct()?.title | propertitlecase }}</li>
					<li>14 Days</li>
					<li>4 Cities</li>
					<li>32 Neighborhoods</li>
				</ul>
			</div>

			<div class="receipt-breakdown">
				<div class="breakdown-row">
					<span class="breakdown-label">Subtotal</span>
					<span class="breakdown-value"> {{ receiptSubtotal() | number: '1.2-2' | currency }}</span>
				</div>
				<div class="breakdown-row">
					<span class="breakdown-label">Tax</span>
					<span class="breakdown-value"> {{ receiptTax() | number: '1.2-2' | currency }}</span>
				</div>
				<div class="breakdown-row breakdown-total">
					<span class="breakdown-label">Total</span>
					<span class="breakdown-value"> {{ receiptTotal() | number: '1.2-2' | currency }}</span>
				</div>
			</div>

			<sp-button class="store-receipt-dashboard-btn" [label]="'Back to Dashboard'" (clicked)="onDone()"></sp-button>
		</div>
	}
</div>
